export default __webpack_public_path__ + "static/media/Tijofi_Ts_20.5acff7bf.jpg";